<template>
  <div class="top-contain">
    <!-- <el-scrollbar style="height: 100%"> -->
    <div class="icon_content">
      <!-- 顶部标题 -->
      <div class="title_box">
        <div class="title_item left" style="margin-left:430px">下单关怀</div>
        <div class="title_item content" style="margin-left:266px">订单关怀</div>
        <div class="title_item right" style="margin-left:260px">售后关怀</div>
        <div class="back_div back_div_left" style="left: 75px;top: 11px;"></div>
        <div class="back_div back_div_content" style="left: 637px;top: 11px; width: 326px;"></div>
        <div class="back_div back_div_right" style="right: 143px;top: 11px; width: 520px;"></div>
      </div>
      <div class="icons_box">
        <div class="top_icon">
          <!-- 下单关怀（货到） -->
          <div class="link_item" style="" @click="jumpToPage('/orderCare/orderCare/goodsOrderCare', orderCareInfo.goodsOrderCare)">
            <span v-if="openInfo.remindSellerConfigData['11']" class="isOpen">已开启</span>
            <img v-if="!orderCareInfo.goodsOrderCare" src="@/assets/new-homeIcon/disabled/disa-下单关怀.png" alt="" />
            <img
              v-else-if="asideName == '下单关怀（货到）' && orderCareInfo.goodsOrderCare"
              src="@/assets/new-homeIcon/icon_下单关怀_s.png"
              class="link_icon"
            />
            <img v-else src="@/assets/new-homeIcon/icon_下单关怀_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '下单关怀（货到）' }">下单关怀<br />（货到）</div>
          </div>
          <div style=" float:left" class="margin">
            <div class="icon-item second top" style="margin-top: 25px;">
              <!-- <div class="icon-infont"></div> -->
              <div class="icon-infont_content dotted"></div>
              <!-- <div class="icon-infont_opp"></div> -->
            </div>
          </div>
          <div class="link_item" style="" @click="jumpToPage('/orderCare/orderCare/expediting', orderCareInfo.expediting)">
            <span v-if="openInfo.remindSellerConfigData['8']" class="isOpen">已开启</span>
            <img v-if="!orderCareInfo.expediting" src="@/assets/new-homeIcon/disabled/disa-常规催付.png" alt="" />
            <img v-else-if="asideName == '催付提醒' && orderCareInfo.expediting" src="@/assets/new-homeIcon/icon_常规催付_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_常规催付_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '催付提醒' }">催付提醒</div>
          </div>

          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>
          <!-- 二次催付 -->
          <!-- <div class="link_item" style="" @click="jumpToPage('/orderCare/orderCare/twiceExpediting', orderCareInfo.twiceExpediting)">
            <span v-if="openInfo.remindSellerConfigData['12']" class="isOpen">已开启</span>
            <img v-if="!orderCareInfo.twiceExpediting" src="@/assets/new-homeIcon/disabled/disa-二次催付.png" alt="" />
            <img
              v-else-if="asideName == '二次催付' && orderCareInfo.twiceExpediting"
              src="@/assets/new-homeIcon/icon_二次催付_s.png"
              class="link_icon"
            />
            <img v-else src="@/assets/new-homeIcon/icon_二次催付_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '二次催付' }">二次催付</div>
          </div>
          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div> -->
          <!-- 付款关怀 -->
          <div class="link_item" style="" @click="jumpToPage('/orderCare/payReminder/payReminder', orderCareInfo.payReminder)">
            <span v-if="openInfo.remindSellerConfigData['1']" class="isOpen">已开启</span>
            <img v-if="!orderCareInfo.payReminder" src="@/assets/new-homeIcon/disabled/disa-付款关怀.png" alt="" />
            <img v-else-if="asideName == '付款关怀' && orderCareInfo.payReminde" src="@/assets/new-homeIcon/icon_付款关怀_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_付款关怀_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '付款关怀' }">付款关怀</div>
          </div>
          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>
          <!-- 发货提醒 -->
          <div class="link_item" style="" @click="jumpToPage('/orderCare/transreMind/sendreMind', orderCareInfo.sendreMind)">
            <span v-if="openInfo.remindSellerConfigData['2']" class="isOpen">已开启</span>
            <img v-if="!orderCareInfo.sendreMind" src="@/assets/new-homeIcon/disabled/disa-发货提醒.png" alt="" />
            <img v-else-if="asideName == '发货提醒' && orderCareInfo.sendreMind" src="@/assets/new-homeIcon/icon_发货提醒_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_发货提醒_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '发货提醒' }">发货提醒</div>
            <!-- <img v-if="venderType" style="padding-top:5px" src="@/assets/images/icon_qt.png" alt="" /> -->
          </div>
          <!-- <div v-if="!venderType" style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>
           <div v-if="!venderType" class="link_item" style="" @click="jumpToPage('/orderCare/transreMind/delivereMind')">
            <span v-if="openInfo.remindSellerConfigData['13']" class="isOpen">已开启</span>
            <img v-if="asideName == '派件提醒'" src="@/assets/new-homeIcon/icon_派件提醒_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_派件提醒_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '派件提醒' }">派件提醒</div>
          </div>
          <div v-if="!venderType" style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div> 
          </div> -->

          <!-- <div v-if="!venderType" class="link_item" style="" @click="jumpToPage('/orderCare/transreMind/recvreMind')">
            <span v-if="openInfo.remindSellerConfigData['14']" class="isOpen">已开启</span>
            <img v-if="asideName == '签收提醒'" src="@/assets/new-homeIcon/icon_签收提醒_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_签收提醒_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '签收提醒' }">签收提醒</div>
          </div> -->
          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>

          <div class="link_item" style="" @click="jumpToPage('/orderCare/moneyBack/moneyBack', orderCareInfo.moneyBack)">
            <span v-if="openInfo.remindSellerConfigData['5']" class="isOpen">已开启</span>
            <img v-if="!orderCareInfo.moneyBack" src="@/assets/new-homeIcon/disabled/disa-完成提醒.png" alt="" />
            <img v-else-if="asideName == '完成提醒' && orderCareInfo.moneyBack" src="@/assets/new-homeIcon/icon_完成提醒_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_完成提醒_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '完成提醒' }">完成提醒</div>
            <!-- <img v-if="venderType" style="padding-top:5px" src="@/assets/images/icon_qt.png" alt="" /> -->
          </div>
          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>

          <div class="link_item" style="" @click="jumpToPage('/orderCare/comtCare/autoEvaluation', orderCareInfo.autoEvaluation)">
            <span v-if="openInfo.popCommentConfigData['1']" class="isOpen">已开启</span>
            <img v-if="!orderCareInfo.autoEvaluation" src="@/assets/new-homeIcon/disabled/disa-自动催评.png" alt="" />

            <img
              v-else-if="asideName == '自动催评' && orderCareInfo.autoEvaluation"
              src="@/assets/new-homeIcon/icon_催评提醒_s.png"
              class="link_icon"
            />
            <img v-else src="@/assets/new-homeIcon/icon_催评提醒_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '自动催评' }">自动催评</div>
          </div>

          <!-- 好感度 自营 -->
          <template v-if="venderType == true">
            <div style=" float:left" class="margin">
              <div class="icon-item top" style="margin-top: 25px;">
                <div class="icon-infont"></div>
                <div class="icon-infont_content"></div>
                <div class="icon-infont_opp"></div>
              </div>
            </div>

            <div class="link_item" style="" @click="jumpToPage('/orderCare/comtCare/thankEvaluationOfficial', orderCareInfo.thankEvaluationOfficial)">
              <span v-if="openInfo.popCommentConfigData['2']" class="isOpen">已开启</span>
              <img v-if="!orderCareInfo.thankEvaluationOfficial" src="@/assets/new-homeIcon/disabled/disa-好评感谢.png" alt="" />
              <img
                v-else-if="asideName == '好评感谢（自营）' && orderCareInfo.thankEvaluationOfficial"
                src="@/assets/new-homeIcon/icon_好评感谢_s.png"
                class="link_icon"
              />
              <img v-else src="@/assets/new-homeIcon/icon_好评感谢_n.png" class="link_icon" />
              <div class="link_title" :class="{ select_text: asideName == '好评感谢' }">好评感谢</div>
            </div>
            <div style=" float:left" class="margin">
              <div class="icon-item top" style="margin-top: 25px;">
                <!-- <div class="icon-infont"></div> -->
                <div class="icon-infont_content dotted"></div>
                <!-- <div class="icon-infont_opp"></div> -->
              </div>
            </div>

            <div class="link_item" style="" @click="jumpToPage('/orderCare/comtCare/poorEvaluationOfficial', orderCareInfo.poorEvaluationOfficial)">
              <span v-if="openInfo.popCommentConfigData['3']" class="isOpen">已开启</span>
              <img v-if="!orderCareInfo.poorEvaluationOfficial" src="@/assets/new-homeIcon/disabled/disa-中差评安抚.png" alt="" />

              <img
                v-else-if="asideName == '中差评安抚（自营）' && orderCareInfo.poorEvaluationOfficial"
                src="@/assets/new-homeIcon/icon_中差评安抚_s.png"
                class="link_icon"
              />
              <img v-else src="@/assets/new-homeIcon/icon_中差评安抚_n.png" class="link_icon" />
              <div class="link_title" :class="{ select_text: asideName == '中差评安抚' }">中差评安抚</div>
            </div>
          </template>

          <!-- <div v-if="!venderType" style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div style="margin-left: 8px;width: 21px;" class="icon-infont_content_ju"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>

          <div v-if="!venderType" class="link_item" style="" @click="jumpToPage('/orderCare/refunCare/deny')">
            <span v-if="openInfo.refundRemindConfigData['3']" class="isOpen">已开启</span>
            <img v-if="asideName == '拒绝退款'" src="@/assets/new-homeIcon/icon_拒绝退款_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_拒绝退款_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '拒绝退款' }">拒绝退款</div>
          </div> -->
        </div>
        <!-- 下半部分 -->
        <div class="bottom_icon">
          <div class="order_care_bottom" style=" height:1px; float:left"></div>
          <div class="link_item" style="" @click="jumpToPage('/orderCare/orderCare/presaleExpediting', orderCareInfo.presaleExpediting)">
            <div class="top" style="margin-left: 24px; margin-bottom: 10px">
              <div class="icon-infont3"></div>
              <div class="icon-infont4" style="float:left"></div>
              <div class="icon-infont4_opp" style="float:left"></div>
            </div>
            <span v-if="openInfo.remindSellerConfigData['24']" class="isOpen bottom_item">已开启</span>
            <img v-if="!orderCareInfo.presaleExpediting" src="@/assets/new-homeIcon/disabled/disa-预售尾款催付.png" alt="" />

            <img
              v-else-if="asideName == '预售尾款催付' && orderCareInfo.presaleExpediting"
              src="@/assets/new-homeIcon/icon_预售尾款催付_s.png"
              class="link_icon"
            />
            <img v-else src="@/assets/new-homeIcon/icon_预售尾款催付_n.png" class="link_icon" />
            <div class="link_title" style="width:80px;position:absolute;left:-17px" :class="{ select_text: asideName == '预售尾款催付' }">
              预售尾款催付
            </div>
          </div>
          <div class="order_care_bottom_cancelMind" style=" height:1px; float:left"></div>
          <div class="link_item" style="" @click="jumpToPage('/orderCare/transreMind/cancelMind', orderCareInfo.cancelMind)">
            <div class="top" style="margin-left: 24px; margin-bottom: 10px">
              <div class="icon-infont3"></div>
              <div class="icon-infont4" style="float:left"></div>
              <div class="icon-infont4_opp" style="float:left"></div>
            </div>
            <span v-if="openInfo.remindSellerConfigData['6']" class="isOpen bottom_item">已开启</span>
            <img v-if="!orderCareInfo.cancelMind" src="@/assets/new-homeIcon/disabled/disa-取消提醒.png" alt="" />

            <img v-else-if="asideName == '取消提醒' && orderCareInfo.cancelMind" src="@/assets/new-homeIcon/icon_取消提醒_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_取消提醒_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '取消提醒' }">取消提醒</div>
          </div>

          <!-- 迟发提醒   自营 -->
          <div class="link_item" style="" @click="jumpToPage('/orderCare/transreMind/delayMind', true)">
            <div class="top" style="margin-left: 24px; margin-bottom: 10px;margin-right: 5px;float: left;">
              <div class="icon-infont3" style="height:94px"></div>
              <div class="icon-infont"></div>
              <div style="width:44px" class="icon-infont_content"></div>
              <div style="top:108px" class="icon-infont_opp"></div>
            </div>
            <span v-if="openInfo.remindSellerConfigData['3']" class="isOpen bottom_item">已开启</span>
            <div style="float: left;margin-top: 74px;">
              <img v-if="asideName == '迟发提醒'" src="@/assets/new-homeIcon/icon_迟发提醒_s.png" class="link_icon" />
              <img v-else src="@/assets/new-homeIcon/icon_迟发提醒_n.png" class="link_icon" />
              <div class="link_title" :class="{ select_text: asideName == '迟发提醒' }">迟发提醒</div>
              <!-- <img style="padding:5px 0" src="@/assets/images/icon_qt.png" alt="" /> -->
            </div>
          </div>

          <div class="order_care_bottom_delayMind" style=" height:1px; float:left"></div>
          <div class="order_care_bottom_delayMind apply" style="width:219px; height:1px; float:left;"></div>
        </div>
      </div>
    </div>
    <!-- </el-scrollbar> -->
  </div>
</template>

<script>
export default {
  props: {
    asideName: {
      type: String,
      default: "",
    },
    openInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      selectIndex: "",
      orderCareInfo: {
        goodsOrderCare: false,
        expediting: false,
        twiceExpediting: false,
        presaleExpediting: false,
        payReminder: false,
        cancelMind: false,
        sendreMind: false,
        moneyBack: false,
        autoEvaluation: false,
        thankEvaluationOfficial: false,
        poorEvaluationOfficial: false,
      },
    };
  },
  mounted() {
    const menu = this.$store.state.route;
    menu.forEach((item) => {
      if (item.tittle == "订单关怀") {
        item.children.forEach((ele) => {
          ele.children.forEach((i) => {
            if (i.path == "goodsOrderCare") {
              this.orderCareInfo.goodsOrderCare = true;
            }
            if (i.path == "expediting") {
              this.orderCareInfo.expediting = true;
            }
            if (i.path == "twiceExpediting") {
              this.orderCareInfo.twiceExpediting = true;
            }
            if (i.path == "presaleExpediting") {
              this.orderCareInfo.presaleExpediting = true;
            }
            if (i.path == "payReminder") {
              this.orderCareInfo.payReminder = true;
            }
            if (i.path == "cancelMind") {
              this.orderCareInfo.cancelMind = true;
            }
            if (i.path == "sendreMind") {
              this.orderCareInfo.sendreMind = true;
            }
            // if(i.path == "迟发提醒"){
            //    this.orderCareInfo.delayMind = true;
            // }
            // if(i.path == "派件提醒"){
            //    this.orderCareInfo.delivereMind = true;
            // }
            // if(i.path == "签收提醒"){
            //    this.orderCareInfo.recvreMind = true;
            // }
            // if(i.path == "退货提醒"){
            //    this.orderCareInfo.goodsBackMind = true;
            // }
            if (i.path == "moneyBack") {
              this.orderCareInfo.moneyBack = true;
            }
            if (i.path == "autoEvaluation") {
              this.orderCareInfo.autoEvaluation = true;
            }
            if (i.path == "thankEvaluationOfficial") {
              this.orderCareInfo.thankEvaluationOfficial = true;
            }
            if (i.path == "poorEvaluationOfficial") {
              this.orderCareInfo.poorEvaluationOfficial = true;
            }
          });
        });
      }
    });
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },
  methods: {
    // 点击图标，路由跳转
    jumpToPage(_val, flay) {
      if (flay) {
        this.selectIndex = 1;
        this.$router.push({ path: _val });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 1980px) {
  .title_box {
    .back_div_right {
      width: 574px !important;
      left: 977px !important;
    }
  }
}
@media only screen and (max-width: 1830px) {
  .title_box {
    .back_div_right {
      width: 430px !important;
      left: 964px !important;
    }
  }
}
@media only screen and (max-width: 1730px) {
  .title_box {
    .left {
      margin-left: 284px !important;
    }
    .content {
      margin-left: 260px !important;
    }
    .right {
      margin-left: 260px !important;
    }
    .back_div_left {
      width: 415px !important;
      left: 62px !important;
    }
    .back_div_content {
      width: 327px !important;
      left: 484px !important;
    }
    .back_div_right {
      width: 496px !important;
      left: 824px !important;
    }
  }
}

@media only screen and (max-width: 1600px) {
  .icon-infont_content {
    width: 42px !important;
  }
  .icon-infont_content_long {
    width: 280px !important;
  }
  .icon-infont3_long {
    left: 306px !important;
  }
  .bottom_icon {
    left: -64px !important;
  }

  .order_care_bottom_cancelMind {
    width: 51px !important;
  }
  .order_care_bottom_delayMind {
    width: 265px;
  }
  .apply {
    width: 186px !important;
  }
  .title_box {
    .left {
      margin-left: 255px !important;
    }
    .content {
      margin-left: 230px !important;
    }
    .right {
      margin-left: 229px !important;
    }
    .back_div_left {
      width: 360px !important;
      left: 62px !important;
    }
    .back_div_content {
      width: 310px !important;
      left: 437px !important;
    }
    .back_div_right {
      width: 430px !important;
      left: 764px !important;
    }
  }
}
@media only screen and (max-width: 1480px) {
  .icon-infont_content {
    width: 33px !important;
  }
  .long_top {
    margin-left: 10px !important;
  }
  .icon-infont_content_long {
    width: 272px !important;
    left: -7px !important;
  }
  .icon-infont3_long {
    left: 281px !important;
  }
  .bottom_icon {
    left: -78px !important;
  }
  .order_care_bottom {
    width: 179px !important;
  }
  .order_care_bottom_cancelMind {
    width: 40px !important;
  }

  .apply {
    width: 159px !important;
  }
  .top-contain .margin .long_top {
    height: 42px;
    margin-bottom: 4px;
  }
  .title_box {
    .left {
      margin-left: 237px !important;
    }
    .content {
      margin-left: 206px !important;
    }
    .right {
      margin-left: 203px !important;
    }
    .back_div_left {
      width: 380px !important;
      left: 24px !important;
    }
    .back_div_content {
      width: 270px !important;
      left: 415px !important;
    }
    .back_div_right {
      width: 450px !important;
      left: 695px !important;
    }
  }
}
@media only screen and (max-width: 1411px) {
  .icon-infont_content {
    width: 25px !important;
    //    margin-left: 9px;
  }
  .long_top {
    margin-left: 10px !important;
  }
  .icon-infont_content_long {
    width: 239px !important;
    left: -7px !important;
  }
  .icon-infont3_long {
    left: 247px !important;
  }

  .bottom_icon {
    left: -79px !important;
  }
  .order_care_bottom {
    width: 179px !important;
  }
  .order_care_bottom_cancelMind {
    width: 40px !important;
  }
  .order_care_bottom_delayMind {
    width: 30px !important;
  }
  .apply {
    width: 176px !important;
  }
  .top-contain .margin .long_top {
    height: 42px;
    margin-bottom: 4px;
  }
  .title_box {
    .left {
      margin-left: 229px !important;
    }
    .content {
      margin-left: 185px !important;
    }
    .right {
      margin-left: 177px !important;
    }
    .back_div_left {
      width: 364px !important;
      left: 20px !important;
    }
    .back_div_content {
      width: 253px !important;
      left: 395px !important;
    }
    .back_div_right {
      width: 410px !important;
      left: 660px !important;
    }
  }
}
@media only screen and (max-width: 1350px) {
  .icon-infont_content {
    width: 23px !important;
  }
  .icon-infont_content_ju {
    margin-left: 5px !important;
    width: 14px !important;
  }
  .icon-infont_content_long {
    width: 248px !important;
    left: -7px !important;
  }
  .icon-infont3_long {
    left: 257px !important;
  }

  .bottom_icon {
    left: -88px !important;
  }
  .order_care_bottom {
    width: 179px !important;
  }
  .order_care_bottom_cancelMind {
    width: 40px !important;
  }
  .order_care_bottom_delayMind {
    width: 30px !important;
  }
  .apply {
    width: 150px !important;
  }
  .top-contain .margin .long_top {
    height: 42px;
    margin-bottom: 4px;
  }
  .title_box {
    .left {
      margin-left: 202px !important;
    }
    .content {
      margin-left: 174px !important;
    }
    .right {
      margin-left: 174px !important;
    }
    .back_div_left {
      width: 268px !important;
      left: 1px !important;
    }
    .back_div_content {
      width: 315px !important;
      left: 280px !important;
    }
    .back_div_right {
      width: 388px !important;
      left: 605px !important;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .bottom_icon {
    left: -88px !important;
  }
  .long_top {
    margin-left: 10px !important;
    // height: 45px;
    // margin-bottom: 0px;
  }
  .icon-infont_content_ju {
    margin-left: 19px !important;
  }
  .icon-infont_content_long {
    width: 253px !important;
    left: -7px !important;
  }
  .icon-infont3_long {
    left: 262px !important;
  }
  .top-contain .margin .long_top {
    height: 42px;
    margin-bottom: 4px;
  }
}

.top-contain {
  padding: 10px 34px 15px;
  position: relative;
  .title_box {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    .title_item {
      min-width: 75px;
      background: #fff;
      z-index: 2;
      color: #999999;
      padding: 2px 8px;
      border: 1px solid#F3F3F3FF;
      height: 24px;
      box-sizing: border-box;
      line-height: 19px;
    }
    .back_div {
      position: absolute;
      width: 550px;
      height: 7px;
      // border-top: 2px ;
      // background: #000;
      border-style: solid;

      border-width: 1px 1px 0;
      // border: 2px solid purple;
      border-color: #eee;
    }
  }
  .icons_box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .top_icon {
    // overflow: hidden;
  }
  .bottom_icon {
    // overflow: hidden;
    position: relative;
    top: -48px;
    left: -58px;
    .order_care_bottom {
      width: 163px;
    }
    .order_care_bottom_cancelMind {
      width: 63px;
    }
    .order_care_bottom_delayMind {
      width: 63px;
    }
  }
  .link_item {
    float: left;
    position: relative;
    cursor: pointer;
    .link_icon {
      width: 50px;
      height: 60px;
      vertical-align: middle;
    }
    .link_title {
      font-size: 12px;
      // font-family:PingFang SC;
      font-weight: 500;
      line-height: 17px;
      color: #999;
      opacity: 1;
    }
    .select_text {
      color: #333;
    }
    .isOpen {
      position: absolute;
      z-index: 5;
      top: 0px;
      right: -23px;
      color: #fff;
      padding: 4px 6px;
      background: rgba(255, 151, 74, 1);
      box-shadow: 0px 2px 4px rgba(255, 151, 74, 0.5);
      opacity: 1;
      border-radius: 43px;
      padding: 2px 5px;
      font-size: 12px;
    }
    .bottom_item {
      top: 74px;
    }
  }
  .margin {
    margin-left: 5px;
    margin-right: 5px;
    // position: absolute;
    // left: 50px;
    // top: 0px
  }
  .icon-item {
    float: left;
  }
  .second {
  }
  .top {
    position: relative;
  }
  .icon-infont_content {
    margin-top: 4px;
    border-style: solid;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-color: #eeeeee;
    width: 52px;
  }
  .icon-infont_content_ju {
    margin-top: 4px;
    border-style: solid;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-color: #eeeeee;
    width: 52px;
  }
  .icon-infont_content_long {
    margin-top: 4px;
    border-style: solid;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-color: #eeeeee;
    width: 52px;
  }
  .dotted {
    border-style: dashed !important;
  }
  .icon-infont {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(45deg);
    transform: rotate(45deg);
    float: right;
  }
  .icon-infont_top {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(45deg);
    transform: rotate(-45deg);
    float: right;
  }
  .icon-infont3 {
    margin-top: 10px;
    height: 60px;
    width: 0;
    /*float: left;*/
    border: 1px solid rgba(230, 230, 230, 1);
    margin-bottom: -4px;
  }
  .long_top {
    height: 35px;
    margin-bottom: 11px;
  }
  .icon-infont3_long {
    margin-top: 10px;
    height: 60px;
    width: 0;
    /*float: left;*/
    border: 1px solid rgba(230, 230, 230, 1);
    margin-bottom: -4px;
  }
  .icon-infont4 {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(135deg);
    transform: rotate(135deg);
    float: right;
  }
  .icon-infont4_opp {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(135deg);
    transform: rotate(-135deg);
    position: absolute;
    left: -6px;
  }
  .icon-infont_left {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(45deg);
    transform: rotate(-45deg);
    float: right;
  }
  .icon-infont_opp {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(45deg);
    transform: rotate(-45deg);
    float: right;
    position: absolute;
    right: 0px;
    top: 8px;
  }
  .icon-infont_opp_top {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(45deg);
    transform: rotate(45deg);
    float: right;
    position: absolute;
    right: 0px;
    top: 8px;
  }
  .icon_content {
    position: relative;
    height: 265px;
    text-align: center;
    margin-top: 10px;
    // margin-bottom: 10px;
    // display: -webkit-box;
  }
  .modules_title {
    font-size: 14px;
    height: 20px;
    color: #333;
    font-weight: bold;
    line-height: 20px;
  }
  .order_care_top {
    overflow: hidden;
  }
}
</style>
